import { Component, OnInit, Input } from '@angular/core';
import * as firebase from 'firebase/app';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
@Component({
  selector: 'app-section1-3',
  templateUrl: './section1-3.component.html',
  styleUrls: ['./section1-3.component.css'],
  providers : [LogisticsService]
})
export class Section13Component implements OnInit {
  currency:any;
  branches:any;
  driverShipmentDetails:any;
  @Input("role") role;
  constructor(private ls:LogisticsService) { }

  ngOnInit() {
    this.getBranches();
    setTimeout(() => {
      this.getDriverShipmentsHistory();
    }, 300);
    this.getCurrency();
  }
  getCurrency()
  {
    this.ls.currency.subscribe(currency => {
      this.currency = currency; 
    });
  }
  getDriverShipmentsHistory()
  {
    firebase.database().ref("users").orderByChild("role").equalTo("driver").on("value",(data)=>{
      var drivers = data.val();
      this.driverShipmentDetails = [];
      var date = new Date();
      var today = date.getDate() +"/"+  (date.getMonth() + 1) +"/"+  date.getFullYear();
      for(let i in drivers)
      {
          if(this.role == 'admin')
          {
            var branchKey =drivers[i].branch;
            if(branchKey == localStorage.getItem("branch"))
           {
            var y = drivers[i];
            y["branchName"] = this.branches[branchKey].name;
            firebase.database().ref("users").child(i).child("assignedOrders").orderByChild("date").equalTo(today).on("value",(ordersData)=>{
              var orders = ordersData.val();
              var intransit = 0;
              var delivered = 0;
              var pickedup = 0;
              if(orders!=null)
              {
                for(let i in orders)
                {
                  if(orders[i].status == 8)
                  {
                    intransit++;
                  }
                  else if(orders[i].status == 9)
                  {
                    delivered++;
                  }
                  else if(orders[i].status == 7)
                  {
                    pickedup++;
                  }
                }
              }
              y["intransit"] = intransit;
              y["delivered"] = delivered;
              y["pickedup"] = pickedup;
              y["totalCount"] = y["intransit"] + y["delivered"] + y["pickedup"];
            });
            firebase.database().ref("users").child(i).child("cashCollectedHistory").orderByChild("date").equalTo(today).on("value",(cashCollectedDatas)=>{
              var cashCollectedData = cashCollectedDatas.val();
              var totalCashCollected = 0;
              if(cashCollectedData!=null)
              {
                for(let i in cashCollectedData)
                {
                  totalCashCollected = totalCashCollected + cashCollectedData[i].amount;
                }
              }
              y["cashCollected"] = totalCashCollected;
            });
            if(y["intransit"]> 0 || y["delivered"] > 0 || y["pickedup"] > 0 || y["totalCount"] > 0 )
            this.driverShipmentDetails.push(y);
          }
        }
        else
        {
          var y = drivers[i];
          var branchKey =drivers[i].branch;
          y["branchName"] = this.branches?this.branches[branchKey]?this.branches[branchKey].name:"":"";
        firebase.database().ref("users").child(i).child("assignedOrders").orderByChild("date").equalTo(today).on("value",(ordersData)=>{
          var orders = ordersData.val();
          //console.log("orders",orders);
          var intransit = 0;
          var delivered = 0;
          var pickedup = 0;
          if(orders!=null)
          {
            for(let i in orders)
            {
              if(orders[i].status == 8)
              {
                intransit++;
              }
              else if(orders[i].status == 9)
              {
                delivered++;
              }
              else if(orders[i].status == 7)
              {
                pickedup++;
              }
            }
          }
          y["intransit"] = intransit;
          y["delivered"] = delivered;
          y["pickedup"] = pickedup;
          y["totalCount"] = y["intransit"] + y["delivered"] + y["pickedup"];
        });
        firebase.database().ref("users").child(i).child("cashCollectedHistory").orderByChild("date").equalTo(today).on("value",(cashCollectedDatas)=>{
          var cashCollectedData = cashCollectedDatas.val();
          var totalCashCollected = 0;
          if(cashCollectedData!=null)
          {
            for(let i in cashCollectedData)
            {
              totalCashCollected = totalCashCollected + cashCollectedData[i].amount;
            }
          }
          y["cashCollected"] = totalCashCollected;
        });
        if(y["intransit"]> 0 || y["delivered"] > 0 || y["pickedup"] > 0 || y["totalCount"] > 0 )
        this.driverShipmentDetails.push(y);
        //console.log("drivers",this.driverShipmentDetails);
       }
      }
    });
  }
  getBranches()
  {
    firebase.database().ref("branches").on("value",(data)=>{
      this.branches = [];
      var branches = data.val();
      for(let i in branches)
      {
        this.branches[i] = branches[i];
      }
    })
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/section1-3/section1-3.component.ts